import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars
import { useEffect, useState } from "preact/hooks";

import utils from "../../helpers/utils";

import Table from "../components/Table";

import ColumnData from "./Components/ColumnData";
import FilterData from "./Components/FilterData";

interface IAppProps {
  apiUrl: string;
  pageSize: number;
  enableFiltering: boolean;
  fscsAmount: number;
}

const App: FunctionComponent<IAppProps> = ({ apiUrl, pageSize, enableFiltering, fscsAmount }) => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<boolean>(false);
  const [defaultFilter, setDefaultFilter] = useState<string>();

  const urlParams = utils.decodeParams();
  const jointFscsAmount = fscsAmount * 2;
  const params = Object.assign({}, urlParams);
  setDefaultFilter(params.clientType);

  const getFormattedMaxDeposit = (maxDeposit: any): any => {
    const maxDep = Number(maxDeposit);
    return maxDep == jointFscsAmount ? fscsAmount : maxDep;
  };

  const getCurrentRateDetails = (details: any): any => {
    const now = new Date();
    if (details.startDate != null) {
      return details.rateDetails.find((el) => {
        return new Date(el.startDate) >= now;
      });
    } else {
      return details.rateDetails.find((el) => {
        return (
          (new Date(el.startDate) <= now && new Date(el.endDate) > now) ||
          (new Date(el.startDate) <= now && el.endDate == null)
        );
      });
    }
  };
  useEffect(() => {
    if (apiUrl) {
      fetchResults();
    }
  }, []);

  const fetchResults = (): Promise<void> => {
    return fetch(apiUrl).then(function (res) {
      if (res.status != 200) {
        setError(true);
        return;
      }
      res.json().then(function (data) {
        var formattedData = data.content.map(
          (item) =>
            new Date(item.productAvailability.availableFrom) <= new Date() &&
            (item.productAvailability.availableUntil == null ||
              new Date(item.productAvailability.availableUntil) >= new Date()) && {
              id: item.productId,
              bankName: item.bank.bankName,
              productType: item.productType,
              sharia: item.exoticType === "SHARIA" ? "SHARIA" : "N/A",
              minDeposit: item.depositRequirement.min,
              maxDeposit: getFormattedMaxDeposit(item.depositRequirement.max),
              jointMaxDeposit: item.depositRequirement.max,
              featureNoticePeriod: item.periodFeature.noticePeriod,
              featureTermPeriod: item.periodFeature.termPeriod,
              aerRate:
                getCurrentRateDetails(item) != undefined
                  ? (100 * getCurrentRateDetails(item).aerRate).toFixed(2) + "%"
                  : null,
              grossRate:
                getCurrentRateDetails(item) != undefined
                  ? (100 * getCurrentRateDetails(item).grossRate).toFixed(2) + "%"
                  : null,
              accountHolderTypes: item.accountHolderTypes,
            }
        );
        var filteredData = formattedData.filter((x) => x.aerRate != null && x.grossRate != null);
        setData(filteredData);
      });
    });
  };

  return (
    data &&
    !error && (
      <Table
        columns={ColumnData}
        data={data}
        pageSize={pageSize}
        enableFiltering={enableFiltering}
        filterFields={FilterData}
        defaultFilter={defaultFilter}
      ></Table>
    )
  );
};

export default App;
